import { render, staticRenderFns } from "./SmsBlocTabsSteps.vue?vue&type=template&id=46947609&"
import script from "./SmsBlocTabsSteps.vue?vue&type=script&lang=js&"
export * from "./SmsBlocTabsSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports